module.exports = __webpack_public_path__ + "static/index/img/baikal-119.e66db864.jpg";